import { Box, HStack, Text, VStack } from '@elkaso-app/web-design';
import React from 'react';

interface VaultSummary {
  totalRequired: number;
  totalUploaded: number;
  totalExpired: number;
  isComplete: boolean;
}

interface VaultSummaryBarProps {
  summary: VaultSummary;
}

const StatCard: React.FC<{ label: string; value: number; color: string }> = ({ label, value, color }) => (
  <Box bg='white' border='1px' borderColor='gray.200' borderRadius='lg' p='md' minW='160px' textAlign='center'>
    <Text fontSize='2xl' fontWeight='bold' color={color}>
      {value}
    </Text>
    <Text fontSize='sm' color='gray.500'>
      {label}
    </Text>
  </Box>
);

export const VaultSummaryBar: React.FC<VaultSummaryBarProps> = ({ summary }) => {
  return (
    <VStack align='stretch' spacing='md' mb='lg'>
      <HStack spacing='md' flexWrap='wrap'>
        <StatCard label='Total Required' value={summary.totalRequired} color='blue.600' />
        <StatCard label='Total Uploaded' value={summary.totalUploaded} color='green.600' />
        <StatCard label='Total Expired' value={summary.totalExpired} color='red.600' />
      </HStack>
    </VStack>
  );
};
